import { useEffect, useRef, useState } from 'react';

const MINI_PROGRAM_NAME = '心语岛测试';
const MINI_PROGRAM_CODE = '/assets/promo/xinyudao-miniprogram-code.jpg';

type Props = {
  onClose: () => void;
};

function isWeChatBrowser() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}

function fallbackCopy(text: string) {
  const input = document.createElement('textarea');
  input.value = text;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();
  const copied = document.execCommand('copy');
  input.remove();
  return copied;
}

export function MoreTestsModal({ onClose }: Props) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const [feedback, setFeedback] = useState('微信扫一扫，或长按小程序码识别');

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  async function copyName() {
    try {
      if (window.navigator.clipboard?.writeText) {
        await window.navigator.clipboard.writeText(MINI_PROGRAM_NAME);
      } else if (!fallbackCopy(MINI_PROGRAM_NAME)) {
        throw new Error('copy failed');
      }
      setFeedback(`已复制“${MINI_PROGRAM_NAME}”`);
    } catch {
      setFeedback(`请手动复制：${MINI_PROGRAM_NAME}`);
    }
  }

  function saveCode() {
    if (isWeChatBrowser()) {
      setFeedback('请长按上方小程序码，选择保存图片或识别小程序');
      return;
    }

    const link = document.createElement('a');
    link.href = MINI_PROGRAM_CODE;
    link.download = '心语岛测试-小程序码.jpg';
    link.click();
    setFeedback('小程序码已开始下载');
  }

  return (
    <div className="more-tests-backdrop" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className="more-tests-dialog" role="dialog" aria-modal="true" aria-labelledby="more-tests-title">
        <button ref={closeButtonRef} className="more-tests-close" type="button" onClick={onClose} aria-label="关闭">×</button>
        <div className="more-tests-flower more-tests-flower-left" aria-hidden="true">✿</div>
        <div className="more-tests-flower more-tests-flower-right" aria-hidden="true">✿</div>
        <p className="more-tests-kicker">心语岛测试</p>
        <h2 id="more-tests-title"><strong>10+</strong> 热门测试免费测</h2>
        <p className="more-tests-description">微信扫码进入「心语岛测试」<br />更多趣味测试持续更新</p>

        <div className="more-tests-code-card">
          <img src={MINI_PROGRAM_CODE} width="258" height="258" alt="心语岛测试小程序码" draggable="false" />
          <div className="more-tests-search-copy" aria-label="微信搜一搜心语岛测试">
            <p><span aria-hidden="true">✣</span>微信搜一搜</p>
            <strong><i aria-hidden="true" />心语岛测试</strong>
          </div>
        </div>

        <span className="more-tests-name">心语岛测试</span>
        <p className="more-tests-feedback" role="status" aria-live="polite">{feedback}</p>
        <div className="more-tests-actions">
          <button type="button" className="more-tests-save" onClick={saveCode}>保存小程序码</button>
          <button type="button" className="more-tests-copy" onClick={copyName}>复制小程序名称</button>
        </div>
      </section>
    </div>
  );
}
